<nz-layout>
  <nz-header class="section-header">
    {{ "Initial Assessments" | translate }}
  </nz-header>
  <nz-content>
    <!-- <app-social-history-questonaire /> -->

    @for (cm of submenu; track cm) {
      @if (cm.path == componentPaths.socialQuestionnaireAmen) {
        <app-dynamic-questionnaire
          [id]="cm.path"
          (QuestionnaireLoadingStatus)="isLoading = $event"
          />
      }
      @if (cm.path == componentPaths.supportingDocumentsAmen) {
        <app-supporting-documents
          [id]="cm.path"
          [isLoading]="isLoading"
          [pagination]="false"
          />
      }
      @if (cm.path == componentPaths.fastProtocolQuestionnaireMediterrenean) {
        <app-fast-protocol-mediterranean-questionnaire 
          [id]="cm.path"
          (QuestionnaireLoadingStatus)="isLoading = $event"
          />
      }
      @if (cm.path == componentPaths.strokeScoreQuestionnaireMediterrenean) {
        <app-stroke-score-mediterranean-questionnaire
          [id]="cm.path"
          (QuestionnaireLoadingStatus)="isLoading = $event"
          />
      }
    }
  </nz-content>
</nz-layout>
